import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import { selectBase } from './base'

export const selectWidgetErrors = createSelector(
  selectBase,
  base => base.error || emptyObj
)
